enum FractionDigits {
  Default = 1,
  Ltr = 2,
  Extended = 2,
  Ctr = 3,
}

export default FractionDigits;
